var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.legalEntity
    ? _c(
        "div",
        { staticClass: "p-10" },
        [
          _c("div", { staticClass: "mb-20 disp-flex" }, [
            _c("div", [
              _c("h1", { staticClass: "mt-0" }, [
                _vm._v(
                  _vm._s(_vm.legalEntity.registration_name) +
                    " (" +
                    _vm._s(_vm.legalEntity.company_id) +
                    ")"
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 5 } },
            [
              _c(
                "el-col",
                { attrs: { span: 14 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("legal_entity.general_configuration"))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "disp-flex mb-20" }, [
                        _c("div", { staticClass: "mr-10" }, [
                          _c("img", {
                            attrs: {
                              src: _vm.legalEntity.custom_fields.logo_url,
                              width: "100px"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "disp-flex flex-col justify-content-center"
                          },
                          [
                            _c("input", {
                              ref: "file",
                              staticClass: "inputfile",
                              attrs: {
                                id: "file",
                                type: "file",
                                name: "file",
                                accept: "image/png",
                                disabled: _vm.logoLoading
                              },
                              on: { change: _vm.handleFileChange }
                            }),
                            _vm._v(" "),
                            !_vm.logoLoading
                              ? _c(
                                  "label",
                                  {
                                    staticClass: "cursor-pointer",
                                    attrs: { for: "file" }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t("legal_entity.choose_logo")
                                        ) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              : _c("label", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.$t("legal_entity.uploading")) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        { attrs: { "label-width": "120px" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("legal_entity.company_name")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { size: "mini" },
                                model: {
                                  value: _vm.address_form.company_name,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.address_form,
                                      "company_name",
                                      $$v
                                    )
                                  },
                                  expression: "address_form.company_name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("legal_entity.street_name")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { size: "mini" },
                                model: {
                                  value: _vm.address_form.street_name,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.address_form,
                                      "street_name",
                                      $$v
                                    )
                                  },
                                  expression: "address_form.street_name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("legal_entity.street_number")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { size: "mini" },
                                model: {
                                  value: _vm.address_form.street_number,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.address_form,
                                      "street_number",
                                      $$v
                                    )
                                  },
                                  expression: "address_form.street_number"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("legal_entity.zip_code") }
                            },
                            [
                              _c("el-input", {
                                attrs: { size: "mini" },
                                model: {
                                  value: _vm.address_form.zip_code,
                                  callback: function($$v) {
                                    _vm.$set(_vm.address_form, "zip_code", $$v)
                                  },
                                  expression: "address_form.zip_code"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("legal_entity.city") } },
                            [
                              _c("el-input", {
                                attrs: { size: "mini" },
                                model: {
                                  value: _vm.address_form.city,
                                  callback: function($$v) {
                                    _vm.$set(_vm.address_form, "city", $$v)
                                  },
                                  expression: "address_form.city"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "iso_country_code",
                                label: _vm.$t("legal_entity.country")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { size: "mini" },
                                  model: {
                                    value: _vm.address_form.iso_country_code,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.address_form,
                                        "iso_country_code",
                                        $$v
                                      )
                                    },
                                    expression: "address_form.iso_country_code"
                                  }
                                },
                                _vm._l(_vm.countries, function(country, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: country.name,
                                      value: country.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    loading: _vm.loading
                                  },
                                  on: { click: _vm.updateAddress }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.$t("save")) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("legal_entity.payment_plan")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          attrs: {
                            model: _vm.payment_plan_form,
                            "label-width": "200px"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("legal_entity.frequency") }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "Select frequency" },
                                  model: {
                                    value: _vm.payment_plan_form.frequency,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.payment_plan_form,
                                        "frequency",
                                        $$v
                                      )
                                    },
                                    expression: "payment_plan_form.frequency"
                                  }
                                },
                                _vm._l(_vm.periods, function(item) {
                                  return _c("el-option", {
                                    key: item,
                                    attrs: {
                                      label: _vm.$translate.period(item),
                                      value: item
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("legal_entity.maximum_duration")
                              }
                            },
                            [
                              _c("el-slider", {
                                attrs: {
                                  min: _vm.MIN_PERIOD,
                                  step: 1,
                                  "show-input": ""
                                },
                                model: {
                                  value: _vm.payment_plan_form.maximum_duration,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.payment_plan_form,
                                      "maximum_duration",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "payment_plan_form.maximum_duration"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "legal_entity.payment_reference_type"
                                )
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "legal_entity.select_payment_reference_type"
                                    )
                                  },
                                  model: {
                                    value:
                                      _vm.payment_plan_form
                                        .payment_reference_type,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.payment_plan_form,
                                        "payment_reference_type",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "payment_plan_form.payment_reference_type"
                                  }
                                },
                                _vm._l(_vm.paymentReferenceTypes, function(
                                  item
                                ) {
                                  return _c("el-option", {
                                    key: item,
                                    attrs: {
                                      label: _vm.$translate.payment_reference_type(
                                        item
                                      ),
                                      value: item
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    loading: _vm.loading
                                  },
                                  on: { click: _vm.updateProcessingDetails }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.$t("save")) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }